module.exports = __webpack_public_path__ + "tg.svg?6d8fe20fa59fbdbed45f40187876f212";